export default "__VITE_ASSET__c8c898fc__"